import { render, staticRenderFns } from "./KpiShow.vue?vue&type=template&id=4b64ea0a&scoped=true&"
import script from "./KpiShow.vue?vue&type=script&lang=js&"
export * from "./KpiShow.vue?vue&type=script&lang=js&"
import style0 from "./KpiShow.vue?vue&type=style&index=0&id=4b64ea0a&prod&scoped=true&lang=css&"
import style1 from "./KpiShow.vue?vue&type=style&index=1&id=4b64ea0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b64ea0a",
  null
  
)

export default component.exports